module.exports = __webpack_public_path__ + "images/stickers/taco-reading.d38e25e615cbc0d15bea.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-reading.png
// module id = QVWh
// module chunks = 13